import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjGrid from '@mescius/wijmo.react.grid'
import * as wjFilter from '@mescius/wijmo.react.grid.filter'
import * as wjCell from '@mescius/wijmo.grid.cellmaker'
import { idPresentation } from '../../utility'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

export default function ShareGroupList (props) {
  const shareGroups = props.share_groups

  function gridInit (grid) {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        const item = e.getRow().dataItem
        // デフォルトグループのスタイル設定
        if (item.contractor_id) {
          wjCore.addClass(e.cell, 'wj-cell-info')
        }
      }
    })
  }

  return (
    <div className="list-by-grid d-inline-block mw-100">
      <BootstrapAlert class="primary">
        <div>青塗りの共有グループはデフォルトグループです（対応する契約者コードの契約に自動的に設定されます）。</div>
      </BootstrapAlert>
      <wjGrid.FlexGrid itemsSource={shareGroups} isReadOnly={true} initialized={gridInit}>
        <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
        <wjGrid.FlexGridColumn binding="id" header="ID" width={100} cellTemplate={(ctx) => `<a href="${location.href}/${ctx.value}">${idPresentation(ctx.value)}</a>`}></wjGrid.FlexGridColumn>
        <wjGrid.FlexGridColumn binding="name" header="グループ名" width={300}></wjGrid.FlexGridColumn>
        <wjGrid.FlexGridColumn binding="comment" header="メモ" width={300}></wjGrid.FlexGridColumn>
        {props.isShopro && <wjGrid.FlexGridColumn binding="sp_comment" header="ShoProメモ" width={300}></wjGrid.FlexGridColumn>}
        <wjGrid.FlexGridColumn binding="contractor_id" header="契約者コード"></wjGrid.FlexGridColumn>
        <wjGrid.FlexGridColumn align="center" width={80} cellTemplate={wjCell.CellMaker.makeLink({
          text: '詳細',
          // eslint-disable-next-line no-template-curly-in-string
          href: `${location.href}/` + '${item.id}',
          attributes: {
            class: 'btn bg-theme-success py-0'
          }
        })}></wjGrid.FlexGridColumn>
      </wjGrid.FlexGrid>
    </div>
  )
}

ShareGroupList.propTypes = {
  share_groups: PropTypes.arrayOf(PropTypes.object),
  isShopro: PropTypes.bool
}

ShareGroupList.defaultProps = {
  isShopro: false
}

$('#share-group-list').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ShareGroupList {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
